import { __decorate } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { ApiConfig, Frame } from '../../limitPrivateAPI';
let CustomElementNamespace = class CustomElementNamespace extends PrivateAPINamespace {
    getAttributes(compRef) {
        const data = this.ps.ds.components.data.get(compRef) ?? {};
        return JSON.parse(data?.initialAttributes ?? '{}');
    }
    getAttribute(compRef, attributeName) {
        const attributes = this.getAttributes(compRef);
        return attributes[attributeName];
    }
    setAttribute(compRef, attributeName, value) {
        const attributes = this.getAttributes(compRef);
        this.setAttributes(compRef, {
            ...attributes,
            [attributeName]: value,
        });
    }
    setAttributes(compRef, attrs) {
        // TODO: should reload?
        const data = this.ps.ds.components.data.get(compRef) ?? {};
        this.ps.ds.components.data.update(compRef, {
            ...data,
            initialAttributes: JSON.stringify(attrs),
        });
    }
};
CustomElementNamespace.namespace = 'customElement';
CustomElementNamespace = __decorate([
    ApiConfig(Frame)
], CustomElementNamespace);
export { CustomElementNamespace };
//# sourceMappingURL=CustomElementNamespace.js.map